export default String.raw`
dialog.add-variants-to-cart-from-prod-list-popup-background{
    padding: 0;
    border: 0;
    background: transparent;

    .add-variants-to-cart-from-prod-list-popup {
        position: static;
        transform: none;
        width: 100%;
        max-width: unset;
        padding: 32px;
    }

    .customize {
        @include body-1-medium;
        margin-top: 16px;
        margin-bottom: 8px;
    }

    .popup__content{
        margin-top: 16px;
        padding-right: 16px;
        overflow: unset;
        .product {
            display: flex;
            gap: 16px;
            width: 100%;
            align-items: center;
            padding-bottom: 8px;

            &__info {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }

            &__image-wrapper {
                width: 60px;
                height: 60px;
                aspect-ratio: 1;
                border-radius: 4px;
                align-content: center;
                text-align: center;

                svg, img {
                    max-width: 100%;
                    height: auto;
                    max-height: 100%;
                    object-fit: contain;
                    border-radius: 4px;
                }
            }

            &__name {
                @include h4-headline;
                color: $primaryColorFont;
            }

            &__availability {
                @include body-2-regular;
            }
        }

        .attributes {
            max-width: 850px;

            &__wrapper {
                max-height: 400px;
                overflow-y: auto;
                padding-right: 16px;
            }

            @media screen and (min-width: 768px) and (max-width: 1439px) {
                max-width: 100%;
            }
            &:has(.graphical-variants) {
                .attributes__wrapper {
                    display: flex;
                    column-gap: 24px;
                    flex-direction: row-reverse;
                    flex-wrap: wrap;
                    max-width: unset;
                }
                .attributes__container, .attributes__not-last-level-attribute {
                    margin-top: 12px;
                }
            }
            .prices-container {
                margin-top: 48px;
                margin-right: auto;
                &__login-to-see-prices{
                display: flex;
                align-items: center;
                gap: 10px;
                .icon{
                    width: 19px;
                    height: 19px;
                }
                .info{
                    font-size: 14px; 
                    line-height: 20px; 
                }
                }
                &__label{
                color: #767676;
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 5px;
                }
                &__range{
                font-size: 14px; 
                line-height: 20px; 
                }
                &__open-thresholds-popup{
                color: #2E2E2E;
                font-weight: 400;
                text-decoration: underline;
                padding: 0;
                margin-top: 5px !important;
                font-size: 14px; 
                line-height: 20px; 
                }
                &__price-container{
                    display: flex;
                    gap: 8px;
                    align-items: center;
                    margin: 4px 0;
                    .price{
                        font-size: 18px;
                        font-weight: 600;
                        line-height: 24px;
                    }
                    .previous{
                        font-size: 12px;
                        line-height: 18px;
                        color: #767676;
                        text-decoration: line-through;
                    }
                    .label{
                        font-size: 14px; 
                        line-height: 20px;
                        margin-bottom: unset;
                    }
                }
                &__deposit-price {
                    display: flex;
                    font-weight: 400;
                    font-size: 12px; 
                    line-height: 20px; 
                    color: #767676;

                    .deposit, .deposit-js {
                        margin-left: 4px;
                    }
                }
                &__suggested {
                @include body-2-regular;
                height: 24px;
                padding: 8px 0;
                color: #767676;
                }
                &__default-unit-price-container {
                font-size: 12px;
                color: #767676;
                margin-bottom: 4px;
                }

                &__lowest-price{
                font-size: 12px;
                line-height: 16px;
                color: #767676;
                margin-top: 4px;
                margin-bottom: 16px;
                }
                &__unit-price{
                font-size: 12px;
                line-height: 16px;
                margin: 8px 0;
                }
            }

            &__not-last-level-attribute, &__container{
                margin-top: 24px;
                .name{
                    @include body-2-medium;
                }
                .values{
                    display: flex;
                    flex-wrap: wrap;
                    gap: 15px;
                    margin-top: 10px;
                    .value{
                        outline-offset: -2px !important;
                        border: 1px solid $primaryColor;
                        border-radius: 5px;
                        padding: 10px 15px;
                        color: $primaryColor;
                        background-color: #fff;
                        font-size: 14px; 
                        line-height: 20px; 
                        &.active-js{
                            border: 2px solid $primaryColor;
                            font-weight: 600;
                        }
                    }
                }
            }
            &__table-container{
                overflow: auto;
                max-height: 40vh;
                white-space: nowrap;
                position: relative;
                margin-top: 25px;
                table{
                    border: none; 
                    border-collapse: collapse;
                    width: 100%;
                }
                thead{
                    height: auto; 
                    tr{
                        background-color: #fff; 
                        border-bottom: 1px solid #D5D5D5;
                        position: sticky;
                        z-index: 2;
                        top: 0;
                    }
                }
                th{
                    white-space: nowrap;
                    font-weight: 500;
                    font-size: 14px; 
                    line-height: 20px; 
                    &:first-child {
                        z-index: 3;
                        top: 0;
                    }
                }
                tbody{
                    tr{
                        border-bottom: 1px solid #D5D5D5;
                        background-color: #fff;
                        &:last-child{
                            border-bottom: none;
                        }
                        &.attr-container-row {
                            overflow: hidden;
                            transition: height 0.4s ease;
                            
                            td {
                                padding: 0 !important;
                                .last-level-attribute {
                                    &__more-attributes {
                                        width: fit-content !important;
                                        max-height: fit-content;
                                        .attr-container {
                                            width: max-content;
                                            .attribute-editable {
                                                .form__input-wrapper {
                                                    margin: 8px 0 24px;

                                                    .select {
                                                        &__options {
                                                            position: fixed;
                                                            max-width: 247px;
                                                        }
                                                    }
                                                }
                                            }

                                            @media screen and (max-width: 767px) {
                                                display: flex;
                                                flex-direction: column;
                                                width: fit-content;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .name-column{
                        font-size: 12px;
                        line-height: 16px;

                        .pure-button {
                            margin-top: 8px;
                        }
                    }
                    .unit-column{
                        font-size: 14px; 
                        line-height: 20px; 
                        .select__input{
                            display: inline-flex;
                            align-items: center;
                            gap: 10px;
                            justify-content: flex-start;
                            border-bottom: 2px solid $primaryColor;
                            padding: 0 16px 4px 8px;
                            svg{
                                width: 15px;
                                height: 15px;
                                fill: $primaryColor;
                            }
                        }
                        .select__options{
                            width: auto;
                            right: 0;
                        }
                        &__unit-ratio-info{
                            padding: 4px 0 0 7px;
                            max-height: 24px;
                        }
                        &__units {
                            width: fit-content;
                        }
                        .min-quantity-info {
                            display: flex;
                            column-gap: 8px;
                            max-width: 100%;
                            @include body-2-regular;
                            svg {
                                min-width: 20px;
                                min-height: 20px;
                                width: 20px;
                                height: 20px;
                                fill: $warnColor;
                            }
                        }
                    }
                }
                td, th{
                    padding: 8px 16px 8px 0;
                    vertical-align: middle;
                    text-align: left;
                    &:last-child{
                        padding-right: 0;
                    }
                }
                .netto-price-column, .brutto-price-column{
                    &__price {
                        display: flex;
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 20px;
                        align-items: baseline;

                        .price {
                            margin: 0 4px;
                        }
                    }

                    &__deposit-price {
                        display: flex;
                        font-weight: 400;
                        font-size: 12px; 
                        line-height: 20px; 
                        color: #767676;

                        .deposit, .deposit-js {
                            margin-left: 4px;
                        }
                    }
                    
                    &__previous-price{
                        display: inline-block;
                        color: #767676;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 18px;
                        text-decoration: line-through;
                        margin-left: 5px;
                    }
                    &__unit-ratio-info{
                        font-size: 10px;
                        font-weight: 500;
                        line-height: 15px;
                    }
                    &__lowest-price{
                        color: #767676;
                        font-size: 10px;
                        font-weight: 500;
                        line-height: 15px;
                    }
                    .pure-button {
                        min-height: 40px;
                    }
                }
                .thresholds-column{
                    &__label{
                        color: #767676;
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 5px;
                    }
                    &__range{
                        font-size: 14px; 
                        line-height: 20px; 
                    }
                    &__open-thresholds-popup{
                        color: #2E2E2E;
                        font-weight: 400;
                        text-decoration: underline;
                        padding: 0;
                        margin-top: 5px;
                        font-size: 14px; 
                        line-height: 20px; 
                    }
                }

                .notify-about-availability-column{
                    text-align: center;
                    &__button{
                        font-weight: 600;
                        font-size: 14px; 
                        line-height: 20px; 
                    }
                }
                .last-level-attribute.with-attributes{
                    border-bottom: none;
                }
                .attribute-editable{
                    display: inline-block;
                    margin-right: 10px;
                    vertical-align: top;
                    &__name{
                        color: #2E2E2E;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 16px;
                        display: block; 
                    }
                    input{
                        border-radius: 5px;
                        border: 1px solid #4A4A4A;
                        height: 42px;
                        font-size: 14px; 
                        line-height: 20px; 
                    }
                    .select__input{
                        border: 1px solid #4A4A4A;
                        border-radius: 5px;
                        padding: 10px;
                        min-height: 42px;
                    }
                    .select__options li{
                        white-space: normal;
                        font-size: 14px; 
                        line-height: 20px; 
                    }
                    .selected-js{
                        margin-right: 10px;
                        width: 200px;
                        white-space: nowrap;
                        font-size: 14px;
                        line-height: 20px;
                        text-overflow: ellipsis;
                    }
                    svg{
                        width: 15px;
                        height: 15px;
                    }
                }
            }
            .unit-column{
                font-size: 14px; 
                line-height: 20px; 
                .select__input{
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    justify-content: flex-start;
                    border-bottom: 2px solid $primaryColor;
                    padding: 0 16px 4px 8px;
                    svg{
                        width: 15px;
                        height: 15px;
                        fill: $primaryColor;
                    }
                }
                .select__options{
                    width: auto;
                    right: 0;
                }
                &__unit-ratio-info{
                    padding: 4px 0 0 7px;
                    max-height: 24px;
                }
            }
            .stock-column{
                .stock-column-data{
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    gap: 8px;
                    min-width: 110px;
                    flex-wrap: wrap;
                    img{
                        max-height: 16px;
                    }
                    .stock{
                        font-size: 12px;
                        line-height: 16px;
                    }
                }
            }
            .quantity-column .quantity{
                border: 1px solid #767676;
                border-radius: 5px;
                background: $inputsBgColor;
                display: inline-flex;
                width: 107px;
                height: 40px;
                padding: 10px;
                &.validation-error{
                    border: 1px solid $dangerColor;
                    .quantity__input{
                        color: $dangerColor;
                    }
                }
                &__input{
                    background: transparent;
                    font-size: 14px; 
                    line-height: 20px; 
                    border: none;
                    width: 49px;
                    height: 18px;
                    text-align: center;
                }
                &__minus, &__plus{
                    border: none;
                    background: transparent;
                    width: 18px;
                    padding: 0;
                    .icon{
                    width: 11px;
                    height: 11px;
                    fill: #959595;
                    }
                }
            }
            &__buttons{
                margin-top: 30px;
                text-align: right;
                display: flex;
                justify-content: space-between;
                gap: 32px;

                form {
                    display: inline-flex;
                    align-items: center;
                }

                .primary-action-button{
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 10px 20px;
                    outline-offset: -1px !important;
                    svg{
                        flex-shrink: 0;
                        width: 20px;
                        height: 20px;
                    }
                }
                .pure-button{
                    gap: 10px;
                    outline-offset: -1px !important;
                    svg{
                        flex-shrink: 0;
                        width: 14px;
                        height: 14px;
                    }
                }
            }
        }
    }

    .graphical-variants {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;

          &:has(.chip--default) {
            gap: 16px;
          }

          &__container {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-top: 24px;
            margin-right: auto;
            max-width: 400px;

            .min-quantity-info {
                display: flex;
                column-gap: 8px;
                max-width: 100%;
                @include body-2-regular;
                svg {
                    min-width: 20px;
                    min-height: 20px;
                    width: 20px;
                    height: 20px;
                    fill: $warnColor;
                }
            }

            p {
                &.name {
                    @include body-2-medium;

                    .value {
                        @include body-2-regular; 
                    }
                }
            }
          }

          &__attributes {
            margin-top: 16px;
            max-width: 280px;

            .attribute-editable {
                margin-right: 10px;
                vertical-align: top;
                &__name{
                  color: #2E2E2E;
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 16px;
                  display: block; 
                }
                input{
                  border-radius: 5px;
                  border: 1px solid #4A4A4A;
                  height: 42px;
                  font-size: 14px; 
                  line-height: 20px; 
                }
                .select__input{
                  border: 1px solid #4A4A4A;
                  border-radius: 5px;
                  padding: 10px;
                  min-height: 42px;
                }
                .select__options li{
                  white-space: normal;
                  font-size: 14px; 
                  line-height: 20px; 
                }
                .selected-js{
                  margin-right: 10px;
                  width: 200px;
                  white-space: nowrap;
                  font-size: 14px;
                  line-height: 20px;
                  text-overflow: ellipsis;
                }
                svg{
                  width: 15px;
                  height: 15px;
                }
              .form__input-wrapper {
                margin: 8px 0 24px;

                .select {
                  &__options {
                      position: fixed;
                      max-width: 247px;
                  }
                }
              }
            }
          }

          &__quantity-unit {
            display: flex;
            flex-direction: row;
            gap: 12px;
            flex-wrap: nowrap;
            align-items: center;
            margin-top: 12px;
          }

          .chip {
            position: relative;
            display: flex;
            width: 72px;
            height: 72px;
            justify-content: center;
            align-items: center;
            gap: 12px;
            border-radius: 6px;
            border: 1px solid #D5D5D5;
            cursor: pointer;

            &--color {
                width: 40px;
                height: 40px;
                aspect-ratio: 1/1;
                border-radius: 100%;
                border: none;
                padding: 0;

                .multicolor {
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  background: conic-gradient(
                    red,
                    yellow,
                    green,
                    cyan,
                    blue,
                    magenta,
                    red
                  );
                }
            }

            &--default {
              height: 40px;
              width: auto;
              padding: 10px 16px;
              justify-content: center;
              align-items: center;
              border-color: $primaryColor;
              color: $primaryColor;
              background-color: #fff;
              font-size: 14px;
              line-height: 20px; 
            }

            &--showMore {
                width: auto;
                height: auto;
                border: none;

                input[type="checkbox"] {
                    display: none;
                }

                .less {
                    display: none;
                }

            }

            &:has(input[type="checkbox"]:checked) {
                .more {
                    display: none;
                }

                .less {
                    display: inline;
                }
            }

            input {
                position: absolute;
                opacity: 0;
                width: 0;
                height: 0;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 4px;
            }

            &:has(input[type="radio"]:checked) {
                border: 2px solid $primaryColor;
                font-weight: 600;
            }
          }
        }
    
    .at-least-one-product-info {
        color: $dangerColor;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 15px;
        
        svg {
            fill: $dangerColor;
            flex-shrink: 0;
        }
    }
}
`